import { ApplicationState } from './../index';

export const GetUrlBuilderPublicData = (state: ApplicationState) => state.urlBuilderPublic;
export const selectBuilderPublicPermissions = (state: ApplicationState) => state.urlBuilderPublic.permissions;
